export default __webpack_public_path__ + "static/service-branding-e08f81929d9031fa205301543e13c321.svg";